
import { ValidationProvider } from 'vee-validate';
import { Form, FormElement, InputText } from '05-ui-kit';
import { formatPhoneAndMask } from '@artmizu/utils';
import type { CheckoutContact } from '~/type/Checkout';
const __sfc_main = {};
__sfc_main.props = {
  contact: {
    key: "contact",
    required: false,
    type: Object
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  function onChange({
    name = props.contact?.name,
    email = props.contact?.email,
    phone = props.contact?.phone || '+7'
  }) {
    emit('change-data', {
      name,
      email,
      phone: formatPhoneAndMask(phone)
    });
  }
  return {
    onChange
  };
};
__sfc_main.components = Object.assign({
  Form,
  ValidationProvider,
  FormElement,
  InputText
}, __sfc_main.components);
export default __sfc_main;
